import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  formType: 'add' | 'edit'
  updateFormType: (formType: 'add' | 'edit') => void
}

export const UserFormModalContext = createContext<IContext>({
  formType: 'add',
  updateFormType: () => {},
})

export const UserFormModalContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [formType, setFormType] = useState<'add' | 'edit'>('add')

  const updateFormType = (formType: 'add' | 'edit') => {
    setFormType(formType)
  }

  return (
    <UserFormModalContext.Provider
      value={{
        formType,
        updateFormType,
      }}>
      {children}
    </UserFormModalContext.Provider>
  )
}
